export const communityPropertyStates = ['LA', 'AZ', 'CA', 'TX', 'WA', 'ID', 'NV', 'NM', 'WI'];
